import A11yDialog from "a11y-dialog";
import { Controller } from "@hotwired/stimulus";

/**
 *
 */
export default class extends Controller {
  static values = {
    id: String,
  };

  dialog;

  /**
   * @type {NodeListOf<HTMLElement>}
   */
  triggers;

  connect() {
    this.dialog = new A11yDialog(this.element);
    console.log(`[data-dialog-controller-trigger="${this.idValue}"]`);
    this.triggers = document.querySelectorAll(
      `[data-dialog-controller-trigger="${this.idValue}"]`
    );

    this.initEventHandlers();
  }

  initEventHandlers() {
    this.dialog.on("show", this.onShow);
    this.dialog.on("hide", this.onHide);
    this.dialog.on("destroy", this.onDestroy);
    this.dialog.on("create", this.onCreate);

    console.log(this.triggers);

    if (!this.triggers || this.triggers.length === 0) {
      console.log("No dialog triggers found");
    } else {
      for (let trigger of this.triggers) {
        console.log(trigger);
        trigger.classList.add("js");
        trigger.addEventListener("click", (e) => this.show());
      }
    }
  }

  show() {
    this.dialog.show();
  }

  hide() {
    this.dialog.hide();
  }

  onShow(dialogEl, event) {
    document.body.style.position = "fixed";
    document.body.style.top = `-${window.scrollY}px`;
  }

  onHide(dialogEl, event) {
    const scrollY = document.body.style.top;
    document.body.style.position = "";
    document.body.style.top = "";
    window.scrollTo(0, parseInt(scrollY || "0") * -1);
  }

  onDestroy(dialogEl) {}

  onCreate(dialogEl) {}
}
